import Vue from 'vue'
import i18n from '@/i18n'

export function error(message, title) {
    let msg = ''
    if (message) {
        msg = i18n.t(message)
    }

    Vue.notify({
        group: 'error',
        title:
            title != undefined && title != null
                ? i18n.t(title)
                : i18n.t('TOAST_ERROR_TITLE'),
        duration: 4000,
        text: msg
    })
}
export function success(message, title) {
    let msg = ''
    if (message) {
        msg = i18n.t(message)
    }
    Vue.notify({
        group: 'success',
        title:
            title != undefined && title != null
                ? i18n.t(title)
                : i18n.t('TOAST_SUCCESS_TITLE'),
        duration: 4000,
        text: msg
    })
}
